import { Schema } from "effect";

/**
 * Currency schema.
 * The business model currently supports EUR only.
 */
export class CurrencySchema extends Schema.TaggedClass<CurrencySchema>(
  "CurrencySchema"
)("CurrencySchema", {
  code: Schema.Union(Schema.Literal("EUR")),
  symbol: Schema.Union(Schema.Literal("€")),
}) {
  static euro = new CurrencySchema({
    code: "EUR",
    symbol: "€",
  });

  static quick(
    code: typeof CurrencySchema.fields.code.Type,
    symbol: typeof CurrencySchema.fields.symbol.Type
  ) {
    return new CurrencySchema({
      code,
      symbol,
    });
  }
}

export type Currency = typeof CurrencySchema.Type;
